/**
 * Auth token provider contract for API authentication.
 *
 * Consumers (e.g. shell, web.template) provide an implementation that returns the current access token (e.g. from
 * MSAL/Azure AD). No secrets are stored in Conductor; the token is obtained at runtime from the host application.
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Provider that supplies the current Bearer token for API requests. Implement in the host app (e.g. from MSAL or shell
 * auth context).
 */
export interface IAuthTokenProvider {
  /**
   * Returns the current access token, or null/undefined if not authenticated. Can return a Promise or Observable for
   * async token acquisition.
   */
  getToken(): string | null | undefined | Promise<string | null | undefined> | Observable<string | null | undefined>;
}

/** Injection token for the auth token provider. Provide this in the app (e.g. from shell or MSAL service). */
export const AUTH_TOKEN_PROVIDER = new InjectionToken<IAuthTokenProvider>('AUTH_TOKEN_PROVIDER');
